import { Controller } from "@hotwired/stimulus"

// Submits the form it is on. Checkboxes call it on change so a filter
// applies without a button; text inputs submit on Enter as forms always
// have, because re-rendering the frame under a field being typed into
// would take the focus away.
//
// `submitAbove` submits only when the viewport matches
// data-autosubmit-media-value (a min-width query): the trade lists keep
// their filters in a bottom sheet on phones, where a re-render under the
// open sheet would strand it, so there the sheet's own Apply button submits.
export default class extends Controller {
  static values = { media: String }

  submit() {
    this.element.requestSubmit()
  }

  submitAbove() {
    if (!this.hasMediaValue || matchMedia(this.mediaValue).matches) this.submit()
  }
}
